import script from "./BFormGroup.vue?vue&type=script&lang=ts"
export * from "./BFormGroup.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__